import { BadgeCheck, Quote } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

export default function Author() {
  return (
    <section id="autora" data-testid="author-section" className="overflow-hidden py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <Reveal className="relative mx-auto w-full max-w-md">
          <div className="absolute -left-6 -top-6 h-28 w-28 rounded-full bg-ochre/25 blur-xl" />
          <div className="absolute -bottom-8 -right-4 h-36 w-36 rounded-full bg-sage/30 blur-2xl" />
          <div className="relative overflow-hidden rounded-b-3xl rounded-t-[999px] border-4 border-white shadow-[0_30px_60px_-20px_rgba(26,38,29,0.35)]">
            <img
              src="https://images.unsplash.com/photo-1758600587853-3d2138df6b2b?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Jessica Montenegro, nutricionista"
              data-testid="author-photo"
              className="aspect-[4/5] w-full object-cover"
            />
          </div>
          <div className="absolute -right-3 bottom-10 flex items-center gap-2 rounded-full border border-linen bg-white px-4 py-2 shadow-lg">
            <BadgeCheck size={16} className="text-forest" />
            <span className="text-xs font-bold uppercase tracking-wider text-forest">Nutricionista</span>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <Eyebrow>Conheça a autora</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-4 font-serif text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
              Jessica <span className="italic text-terracotta">Montenegro</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-5 max-w-lg text-base leading-relaxed text-moss sm:text-lg">
              Nutricionista apaixonada por descomplicar a alimentação. Depois de anos
              acompanhando pessoas que sabiam <em>o que</em> fazer, mas não conseguiam colocar
              em prática, Jessica criou um método que cabe na vida real: sem terrorismo
              nutricional, sem ingrediente impossível e sem culpa.
            </p>
          </Reveal>
          <Reveal delay={0.26}>
            <blockquote className="mt-8 rounded-3xl border-l-4 border-terracotta bg-sand/70 p-6 sm:p-8">
              <Quote size={20} className="text-terracotta" />
              <p className="mt-3 font-serif text-xl italic leading-relaxed text-ink sm:text-2xl">
                “Comer bem não é sobre perfeição. É sobre ter um método tão simples que
                funciona até na sua pior semana.”
              </p>
            </blockquote>
          </Reveal>
          <Reveal delay={0.32}>
            <ul className="mt-8 flex flex-wrap gap-3">
              {["Nutrição comportamental", "Comida de verdade", "Zero dietas da moda"].map((tag) => (
                <li
                  key={tag}
                  className="rounded-full border border-linen bg-white px-4 py-1.5 text-xs font-semibold text-forest"
                >
                  {tag}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
